export default "__VITE_ASSET__CwFhXbkz__"